"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.LaunchHelper = void 0;
const tslib_1 = require("tslib");
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const hooks_1 = require("@feathersjs/hooks");
const constants_1 = require("../../common/constants");
const globalVars_1 = require("../../common/globalVars");
const error_1 = require("../../error");
const common_1 = require("../../error/common");
const constants_2 = require("../../question/constants");
const errors_1 = require("./errors");
const packageService_1 = require("./packageService");
const constants_3 = require("./constants");
const accountUtils_1 = require("../../common/accountUtils");
class LaunchHelper {
    m365TokenProvider;
    logger;
    constructor(m365TokenProvider, logger) {
        this.m365TokenProvider = m365TokenProvider;
        this.logger = logger;
    }
    async getLaunchUrl(hub, teamsAppId, properties, withLoginHint = true) {
        const capabilities = properties.capabilities;
        const loginHint = withLoginHint
            ? (await this.getUpnFromToken()) ?? "login_your_m365_account" // a workaround that user has the chance to login
            : undefined;
        let url;
        const copilotCapabilities = ["plugin", "copilotGpt"];
        const hasCopilotExtensionOnly = capabilities.length > 0 &&
            capabilities.filter((capability) => !copilotCapabilities.includes(capability))
                .length === 0;
        switch (hub) {
            case constants_2.HubTypes.teams: {
                let installAppPackage = true;
                if (capabilities.length > 0 &&
                    (hasCopilotExtensionOnly ||
                        (!capabilities.includes("staticTab") &&
                            !capabilities.includes("Bot") &&
                            !capabilities.includes("configurableTab") &&
                            properties.isApiMeAAD))) {
                    installAppPackage = false;
                }
                const baseUrl = installAppPackage
                    ? `https://teams.microsoft.com/l/app/${teamsAppId}?installAppPackage=true&webjoin=true`
                    : "https://teams.microsoft.com";
                url = new URL(baseUrl);
                const tid = await this.getTidFromToken();
                if (tid) {
                    url.searchParams.append("tenantId", tid);
                    url.searchParams.append("appTenantId", tid);
                }
                break;
            }
            case constants_2.HubTypes.outlook: {
                const result = await this.getM365AppId(teamsAppId);
                if (result.isErr()) {
                    return (0, teamsfx_api_1.err)(result.error);
                }
                const baseUrl = hasCopilotExtensionOnly
                    ? `${constants_3.outlookBaseUrl}/host/${constants_3.outlookCopilotAppId}`
                    : capabilities.includes("staticTab")
                        ? `${constants_3.outlookBaseUrl}/host/${result.value}`
                        : `${constants_3.outlookBaseUrl}/mail`;
                url = new URL(baseUrl);
                break;
            }
            case constants_2.HubTypes.office:
                {
                    const result = await this.getM365AppId(teamsAppId);
                    if (result.isErr()) {
                        return (0, teamsfx_api_1.err)(result.error);
                    }
                    const baseUrl = hasCopilotExtensionOnly
                        ? `${constants_3.officeBaseUrl}/chat?auth=2`
                        : `${constants_3.officeBaseUrl}/m365apps/${result.value}?auth=2`;
                    url = new URL(baseUrl);
                }
                break;
        }
        if (loginHint) {
            url.searchParams.append("login_hint", loginHint);
        }
        return (0, teamsfx_api_1.ok)(url.toString());
    }
    async getM365AppId(teamsAppId) {
        const sideloadingServiceEndpoint = (0, constants_1.getResourceServiceEndpoint)(constants_1.ResourceServiceType.MOS3);
        const packageService = new packageService_1.PackageService(sideloadingServiceEndpoint, this.logger);
        const sideloadingTokenRes = await this.m365TokenProvider.getAccessToken({
            scopes: (0, constants_1.MosServiceScope)(),
        });
        if (sideloadingTokenRes.isErr()) {
            return (0, teamsfx_api_1.err)(sideloadingTokenRes.error);
        }
        const sideloadingToken = sideloadingTokenRes.value;
        try {
            const m365AppId = await packageService.retrieveAppId(sideloadingToken, teamsAppId);
            if (!m365AppId) {
                return (0, teamsfx_api_1.err)(new errors_1.NotExtendedToM365Error(error_1.CoreSource));
            }
            return (0, teamsfx_api_1.ok)(m365AppId);
        }
        catch (error) {
            return (0, teamsfx_api_1.err)((0, common_1.assembleError)(error));
        }
    }
    async getTidFromToken() {
        try {
            const statusRes = await this.m365TokenProvider.getStatus({
                scopes: (0, accountUtils_1.isSovereignHigh)() ? constants_1.GraphScopes : (0, constants_1.AppStudioScopes)(),
            });
            const tokenObject = statusRes.isOk() ? statusRes.value.accountInfo : undefined;
            return tokenObject?.tid;
        }
        catch {
            return undefined;
        }
    }
    async getUpnFromToken() {
        try {
            const statusRes = await this.m365TokenProvider.getStatus({
                scopes: (0, accountUtils_1.isSovereignHigh)() ? constants_1.GraphScopes : (0, constants_1.AppStudioScopes)(),
            });
            const tokenObject = statusRes.isOk() ? statusRes.value.accountInfo : undefined;
            return tokenObject?.upn;
        }
        catch {
            return undefined;
        }
    }
}
exports.LaunchHelper = LaunchHelper;
tslib_1.__decorate([
    (0, hooks_1.hooks)([(0, globalVars_1.ErrorContextMW)({ component: "LaunchHelper" })]),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, String, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], LaunchHelper.prototype, "getLaunchUrl", null);
//# sourceMappingURL=launchHelper.js.map